module.exports = __webpack_public_path__ + "img/mz1.e54d9a98.jpg";